// v4-提示框
<template>
  <section class="common-tip">
    <ul>
      <transition-group name="tip">
        <li
          v-for="item in domList"
          :key="item.time"
          class="common-tip-even a-4-bg b-1-cl"
          :class="item.color"
        >
          <svg
            v-if="item.type === 'info'"
            class="icon icon-16"
            aria-hidden="true"
          >
            <use xlink:href="#icon-c_3"></use>
          </svg>
          <svg
            v-if="item.type === 'error'"
            class="icon icon-16"
            aria-hidden="true"
          >
            <use xlink:href="#icon-v4_14"></use>
          </svg>
          <svg
            v-if="item.type === 'success'"
            class="icon icon-16"
            aria-hidden="true"
          >
            <use xlink:href="#icon-v4_19"></use>
          </svg>
          <svg
            v-if="item.type === 'warning'"
            class="icon icon-16"
            aria-hidden="true"
          >
            <use xlink:href="#icon-c_6"></use>
          </svg>
          <div class="bg" :style="{ background: item.color }"></div>
          <div class="text" :class="item.type">
            {{ item.message }}
          </div>
        </li>
      </transition-group>
    </ul>
  </section>
</template>
<script>
export default {
  name: "c-tip",
  data() {
    return {
      list: [
        // { text: 'error', time: 3000, type: 'error' },
        // { text: 'success', time: 3000, type: 'success' },
        // { text: 'info', time: 3000, type: 'info' },
        // { text: 'warning', time: 3000, type: 'warning' }
      ],
    };
  },
  computed: {
    domList() {
      const list = [];
      this.list.forEach((item) => {
        let color = "";
        switch (item.type) {
          case "error":
            color = "rgba(202, 61, 61, 0.2)";
            break;
          case "success":
            color = "rgba(9, 91, 232, 0.2)";
            break;
          case "info":
            color = "#1F3F59";
            break;
          case "warning":
            color = "#1F3F59";
            break;
          default:
            color = "#1F3F59";
        }
        list.push({ ...item, ...{ color } });
      });
      return list;
    },
  },
  mounted() {
    this.$bus.$on("alert", ({ type = "info", message }) => {
      const time = new Date().getTime();
      this.list.unshift({
        message,
        type,
        time,
      });
      setTimeout(() => {
        let id = -1;
        this.list.forEach((item, index) => {
          if (item.time === time) id = index;
        });
        this.list.splice(id, 1);
      }, 3000);
    });
  },
};
</script>
<style lang='scss'>
.tip-item-move {
  display: inline-block;
  margin-right: 10px;
}
.tip-enter-active,
.tip-leave-active {
  transition: all 0.3s ease;
}
.tip-enter, .tip-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30%);
}

.common-tip {
  position: fixed;
  left: 50%;
  top: 70px;
  z-index: 100000;
  transform: translate(-50%);
  .info {
    border-left-width: 3px;
    border-left-style: solid;
  }
  .common-tip-even {
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
    // width: 280px;
    min-height: 32px;
    margin-bottom: 26px;
    border-left-width: 0px;
    border-left-style: solid;
    box-sizing: border-box;
    transition: all 0.3s;
    padding: 9px 16px 9px 16px;
    position: relative;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    border-radius: 4px;

    .bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0.9;
      border-radius: 4px;
    }
    .icon {
      position: absolute;
      width: 16px;
      height: 16px;
      top: 12px;
      left: 13px;
      border-radius: 50%;
    }
    .text {
      font-family: "HarmonyOS-Medium" !important;
      font-size: 14px;
      letter-spacing: 0;
      text-align: left;
      line-height: 22px;
      margin-left: 22px;
      word-break: break-all;
      word-wrap: break-word;
      &.error {
        color: var(--theme-color-red);
      }
      &.success {
        color: #095be8;
      }
    }
  }
}
</style>
